import { SET_COMMENTDETAIL } from '../actions';

const commentdetail = (state = [], action) => {
  switch (action.type) {
	case SET_COMMENTDETAIL:
      return [...action.value];  
    default: return state;
  }
}

export default commentdetail;
